import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  show_meeting_data,
  getDistrict,
  getBlockByDistrict,
  getVillageByBlock,
  getAllMeetingDates,
  generateSignedUrl,
} from "../../api/User";
import { useFileViewer } from "../../hooks/useSignedUrl";
import { Modal, Row, Col } from "antd";
import "../Admin/table.css";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import TablePagination from "@mui/material/TablePagination";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";
import Swal from "sweetalert2";
import loader from "../../Images/ajax-loader.gif";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { TextField } from "@mui/material";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";


const ViewMeetingForGramSabhaAdmin = ({ dateFilter }) => {
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const role_id = sessionStorage.getItem("role_id");
  const userId = sessionStorage.getItem("user_id");
  const [meetingData, setMeetingData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [district, setDistrict] = useState([]);
  const [selectedDistrictCode, setSelectedDistrictCode] = useState("");
  const [selectedDistrictName, setSelectedDistrictName] = useState("");
  const [selectedBlockCode, setSelectedBlockCode] = useState("");
  const [selectedBlockName, setSelectedBlockName] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  const [selectedVillageCode, setSelectedVillageCode] = useState("");
  const [block, setBlock] = useState([]);
  const [village, setVillage] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("asc");
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [datesLoading, setDatesLoading] = useState(false);
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [approvalLoading, setApprovalLoading] = useState(false);

  // Use the custom hook for file viewing and downloading
  const { viewFile, downloadFile, loading: fileLoading, error: fileError } = useFileViewer();

  // Compact button style
  const compactBtnStyle = {
    fontSize: "10px",
    padding: "4px 8px",
    minWidth: "100px",
    backgroundColor: "#4763E420",
    color: "#4763E4",
    textTransform: "none",
    border: "1px solid #4763E4",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#4763E4",
      color: "#fff",
    },
    "&:disabled": {
      backgroundColor: "#ccc",
      color: "#666",
      borderColor: "#ccc",
    },
  };

  // FIXED: Use the correct parameter name for date filtering
  const fetchData = async () => {
    const data = {
      role_id: role_id,
      user_id: userId,
      meeting_type: "gram_sabha",
      district_code: selectedDistrictCode || null,
      block_code: selectedBlockCode || null,
      gram_panchayat_code: selectedVillage || null,
      // FIX: Use the correct parameter name based on your backend
      scheduledSabhaDate: selectedDate
        ? selectedDate.format("YYYY-MM-DD")
        : null,
    };

    console.log("Fetching data with filters:", data); // Debug log

    try {
      setLoading(true);
      const res = await show_meeting_data(token, data, page + 1, rowsPerPage, dateFilter);

      console.log("API Response:", res); // Debug log

      if (res.status === "success") {
        const formattedData = res.data.map((item) => {
          const [hours, minutes] = item.sabha_start_time?.split(":") || [
            "00",
            "00",
          ];
          const formattedStartTime = `${hours}:${minutes}`;
          return {
            ...item,
            sabha_date: item.sabha_date
              ? new Date(item.sabha_date).toISOString().split("T")[0]
              : "",
            sabha_start_time: formattedStartTime,
          };
        });

        console.log("Formatted Data Count:", formattedData.length); // Debug log

        setMeetingData(formattedData);
        setFilteredData(formattedData);
        setTotalCount(res.pagination?.total_records || 0);
        setLoading(false);
      } else {
        toast.error(res.message, { autoClose: 1000 });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      toast.error("An error occurred while fetching data.", {
        autoClose: 1000,
      });
    }
  };

  // Fetch unique dates using the dedicated API
  const fetchAvailableDates = async () => {
    try {
      setDatesLoading(true);

      // Prepare filters based on selected location
      const dateFilters = {
        role_id: role_id,
        user_id: userId,
        meeting_type: "gram_sabha",
        district_code: selectedDistrictCode || null,
        block_code: selectedBlockCode || null,
        gram_panchayat_code: selectedVillage || null,
      };

      console.log("Fetching dates with filters:", dateFilters); // Debug log

      // Try the dedicated dates API first
      try {
        const res = await getAllMeetingDates(token, dateFilters, dateFilter);

        if (res.status === "success") {
          const uniqueDates = [
            ...new Set(
              res.data.map((item) =>
                item.sabha_date
                  ? new Date(item.sabha_date).toISOString().split("T")[0]
                  : null
              )
            ),
          ]
            .filter((date) => date !== null)
            .sort((a, b) => new Date(b) - new Date(a));

          console.log("Dates from API:", uniqueDates); // Debug log
          setAvailableDates(uniqueDates);
        } else {
          console.log("Dates API failed, falling back...");
          await fetchDatesFromMeetingData();
        }
      } catch (error) {
        console.log("Dates API error, falling back:", error);
        await fetchDatesFromMeetingData();
      }
    } catch (error) {
      console.error("Error in fetchAvailableDates:", error);
      setAvailableDates([]);
    } finally {
      setDatesLoading(false);
    }
  };

  // Fallback function if getAllMeetingDates doesn't work
  const fetchDatesFromMeetingData = async () => {
    const dateFilters = {
      role_id: role_id,
      user_id: userId,
      meeting_type: "gram_sabha",
      district_code: selectedDistrictCode || null,
      block_code: selectedBlockCode || null,
      gram_panchayat_code: selectedVillage || null,
    };

    try {
      // Fetch first page with larger limit to get dates
      const res = await show_meeting_data(token, dateFilters, 1, 1000, dateFilter);

      if (res.status === "success" && res.data) {
        const uniqueDates = [
          ...new Set(
            res.data.map((item) =>
              item.sabha_date
                ? new Date(item.sabha_date).toISOString().split("T")[0]
                : null
            )
          ),
        ]
          .filter((date) => date !== null)
          .sort((a, b) => new Date(b) - new Date(a));

        setAvailableDates(uniqueDates);
      }
    } catch (error) {
      console.error("Error fetching dates from meeting data:", error);
      setAvailableDates([]);
    }
  };

  useEffect(() => {
    fetchDistrict();
    // Initial fetch of dates
    fetchAvailableDates();
  }, []);

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    selectedDistrictCode,
    selectedBlockCode,
    selectedVillage,
    selectedDate,
    dateFilter
  ]);

  useEffect(() => {
    // Fetch available dates when filters change
    fetchAvailableDates();
  }, [selectedDistrictCode, selectedBlockCode, selectedVillage, dateFilter]);

  const handleDistrictChange = (event) => {
    const selectedCode = event.target.value;
    setSelectedDistrictCode(selectedCode);
    setSelectedBlockCode("");
    setSelectedVillage("");
    setSelectedDate(null);
    setBlock([]);
    setVillage([]);
    setPage(0);

    if (selectedCode) {
      fetchBlockByDistrict(selectedCode);
    }
  };

  const handleBlockChange = (event) => {
    const selectedCode = event.target.value;
    setSelectedBlockCode(selectedCode);
    setSelectedVillage("");
    setSelectedDate(null);
    setVillage([]);
    setPage(0);

    if (selectedCode) {
      fetchVillageByBlock(selectedDistrictCode, selectedCode);
    }
  };

  const handleVillageChange = (event) => {
    const selectedCode = event.target.value;
    setSelectedVillage(selectedCode);
    setSelectedDate(null);
    setPage(0);
  };

  // Handle date change
  const handleDateChange = (date) => {
    console.log("Date selected:", date ? date.format("YYYY-MM-DD") : null); // Debug log
    setSelectedDate(date);
    setPage(0);
    setShowDateDropdown(false);
  };

  // Clear date filter
  const handleClearDate = () => {
    setSelectedDate(null);
    setPage(0);
  };

  const fetchDistrict = async () => {
    try {
      const res = await getDistrict(token, userId, role_id);
      if (res.status === "success") {
        setDistrict(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
      toast.error("An error occurred while fetching district data.", {
        autoClose: 1000,
      });
    }
  };

  const fetchBlockByDistrict = async (districtCode) => {
    try {
      const res = await getBlockByDistrict(
        token,
        districtCode,
        userId,
        role_id
      );
      if (res.status === "success") {
        setBlock(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching block data:", error);
      toast.error("An error occurred while fetching block data.", {
        autoClose: 1000,
      });
    }
  };

  const fetchVillageByBlock = async (districtCode, blockCode) => {
    try {
      const res = await getVillageByBlock(
        token,
        districtCode,
        blockCode,
        userId,
        role_id
      );
      if (res.status === "success") {
        setVillage(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching village data:", error);
      toast.error("An error occurred while fetching village data.", {
        autoClose: 1000,
      });
    }
  };
  const downloadMomVideo = (row) => {
    const base64 = row.mom_upload_base64;
    if (!base64) {
      alert("No video found");
      return;
    }

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: "video/mp4" });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = row.mom_upload?.split(/[\\/]/).pop() || "meeting_video.mp4";

    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const getImageMimeType = (filePath = "") => {
    const lower = filePath.toLowerCase();
    if (lower.endsWith(".png")) return "image/png";
    if (lower.endsWith(".gif")) return "image/gif";
    if (lower.endsWith(".webp")) return "image/webp";
    return "image/jpeg";
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedData = [...meetingData].sort((a, b) => {
    if (!orderBy) return 0;

    let valueA = a[orderBy] ?? "";
    let valueB = b[orderBy] ?? "";

    if (orderBy === "sabha_date") {
      valueA = new Date(valueA);
      valueB = new Date(valueB);
    }

    if (typeof valueA === "string") {
      valueA = valueA.toLowerCase();
      valueB = valueB.toLowerCase();
    }

    if (valueA < valueB) return order === "asc" ? -1 : 1;
    if (valueA > valueB) return order === "asc" ? 1 : -1;
    return 0;
  });

  const paginatedData = sortedData;

  // Handle file viewing with signed URL
  const handleViewFile = async (fileUrl) => {
    if (!fileUrl) {
      Swal.fire({
        icon: "error",
        title: "File Not Available",
        text: "No file uploaded for this entry",
      });
      return;
    }

    try {
      setLoading(true);
      await viewFile(fileUrl, 3600); // 1 hour expiration
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "View Failed",
        text: error?.message || "Unable to view file",
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle file download with signed URL
  const handleDownloadFile = async (fileUrl, fileName = null) => {
    if (!fileUrl) {
      Swal.fire({
        icon: "error",
        title: "File Not Available",
        text: "No file uploaded for this entry",
      });
      return;
    }

    try {
      setLoading(true);
      // Extract filename from URL if not provided
      const downloadFileName = fileName || fileUrl.split("/").pop();
      await downloadFile(fileUrl, downloadFileName, 3600); // 1 hour expiration
      toast.success("Download started successfully", { autoClose: 2000 });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: error?.message || "Unable to download file",
      });
    } finally {
      setLoading(false);
    }
  };


  const getImagePaths = (image_upload) => {
    if (!image_upload) return [];
    return image_upload
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
  };

  // Handle viewing all images in a modal
  const handleViewImage = async (imageUpload) => {
    const paths = getImagePaths(imageUpload);

    if (paths.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Image Not Available",
        text: "No image found for this meeting",
      });
      return;
    }

    try {
      setLoading(true);

      // Generate signed URLs for all images
      const signedUrlPromises = paths.map(path =>
        generateSignedUrl(token, path, 3600)
      );

      const responses = await Promise.all(signedUrlPromises);

      // Filter successful responses
      const signedUrls = responses
        .filter(res => res.status === "success" && res.data?.signed_url)
        .map(res => res.data.signed_url);

      if (signedUrls.length === 0) {
        Swal.fire({
          icon: "error",
          title: "View Failed",
          text: "Unable to load images",
        });
        setLoading(false);
        return;
      }

      // Display all images in a modal
      const imageHtml = signedUrls.map((url, index) =>
        `<div style="margin-bottom: 15px;">
          <p style="font-weight: bold; margin-bottom: 5px;">Image ${index + 1} of ${signedUrls.length}</p>
          <img src="${url}" style="max-width: 100%; height: auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);" />
        </div>`
      ).join('');

      Swal.fire({
        title: `Meeting Images (${signedUrls.length})`,
        html: `<div style="max-height: 500px; overflow-y: auto;">${imageHtml}</div>`,
        width: '800px',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          popup: 'image-gallery-popup'
        }
      });

    } catch (error) {
      console.error("handleViewImage error:", error);
      Swal.fire({
        icon: "error",
        title: "View Failed",
        text: error?.message || "Unable to view images",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleResetFilters = () => {
    setSelectedDistrictCode("");
    setSelectedDistrictName("");
    setSelectedBlockCode("");
    setSelectedBlockName("");
    setSelectedVillage("");
    setSelectedVillageCode("");
    setSelectedDate(null); // Clear date filter
    setBlock([]);
    setVillage([]);
    setPage(0); // reset pagination
    setRowsPerPage(10);
    fetchData(); // reload full data
  };

  const handleOpenApprovalModal = (row) => {
    setSelectedMeeting({
      meeting_id: row.id,
      district: row.district_name || "N/A",
      block: row.block_name || "N/A",
      gram_panchayat: row.panchayat_name || "N/A",
      sabha_date: row.sabha_date || "N/A",
      start_time: row.sabha_start_time || "N/A",
      presiding_officer_name: row.presiding_officer_name || "N/A",
      pdf_key: row.meeting_notice_upload || null,
      status: row.status || "pending",
    });
    setIsApprovalModalOpen(true);
  };

  const handleCloseApprovalModal = () => {
    setIsApprovalModalOpen(false);
    setSelectedMeeting(null);
  };

  const handleApproveSubmit = async (approvalData, signedPdfUrl = null) => {
    setApprovalLoading(true);
    try {
      const currentPdfKey =
        signedPdfUrl ||
        selectedMeeting?.pdf_key ||
        meetingData.find((meeting) => meeting.id === approvalData.meeting_id)?.meeting_notice_upload ||
        null;

      const response = await fetch("http://localhost:5001/api/approve_meeting", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          meeting_id: approvalData.meeting_id,
          status: approvalData.status,
          remarks: approvalData.remarks,
          user_id: userId,
          pdf_key: currentPdfKey,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to approve meeting");
      }

      const data = await response.json();

      if (data.status === "success") {
        toast.success(`Meeting ${approvalData.status} successfully`, { autoClose: 2000 });
        const resolvedPdfKey = signedPdfUrl || data?.data?.pdf_key || currentPdfKey;

        if (resolvedPdfKey) {
          setMeetingData((prev) =>
            prev.map((meeting) =>
              meeting.id === approvalData.meeting_id
                ? {
                  ...meeting,
                  meeting_notice_upload: resolvedPdfKey,
                  status: approvalData.status,
                }
                : meeting
            )
          );
          setFilteredData((prev) =>
            prev.map((meeting) =>
              meeting.id === approvalData.meeting_id
                ? {
                  ...meeting,
                  meeting_notice_upload: resolvedPdfKey,
                  status: approvalData.status,
                }
                : meeting
            )
          );
          setSelectedMeeting((prev) =>
            prev ? { ...prev, pdf_key: resolvedPdfKey, status: approvalData.status } : prev
          );
        }

      } else {
        toast.error(data.message || "Failed to approve meeting", { autoClose: 2000 });
      }
    } catch (error) {
      console.error("Error approving meeting:", error);
      toast.error("Failed to approve meeting", { autoClose: 2000 });
    } finally {
      setApprovalLoading(false);
    }
  };

  // 🔽 SORT HANDLER
  const handleSort = (column) => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };

  const SortableHeader = ({ label, columnKey }) => (
    <div
      onClick={() => handleSort(columnKey)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      <span style={{ fontWeight: 600 }}>{label}</span>

      <div style={{ display: "flex", flexDirection: "column", lineHeight: 0 }}>
        <ArrowDropUpIcon
          style={{
            fontSize: 18,
            color:
              orderBy === columnKey && order === "asc" ? "#000" : "#b0b0b0",
            marginBottom: -6,
          }}
        />
        <ArrowDropDownIcon
          style={{
            fontSize: 18,
            color:
              orderBy === columnKey && order === "desc" ? "#000" : "#b0b0b0",
          }}
        />
      </div>
    </div>
  );

  const sortRecords = (records) => {
    if (!orderBy) return records;

    return [...records].sort((a, b) => {
      let valueA = a[orderBy] ?? "";
      let valueB = b[orderBy] ?? "";

      if (orderBy === "sabha_date") {
        valueA = new Date(valueA);
        valueB = new Date(valueB);
      }

      if (typeof valueA === "string") {
        valueA = valueA.toLowerCase();
        valueB = valueB.toLowerCase();
      }

      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0;
    });
  };

  const handleExportToExcel = async () => {
    try {
      setLoading(true);

      const data = {
        role_id: role_id,
        user_id: userId,
        meeting_type: "gram_sabha",
        district_code: selectedDistrictCode || null,
        block_code: selectedBlockCode || null,
        gram_panchayat_code: selectedVillage || null,
        scheduledSabhaDate: selectedDate
          ? selectedDate.format("YYYY-MM-DD")
          : null,
      };

      // 🔥 Fetch ALL records with current filters including date
      const res = await show_meeting_data(token, data, 1, 100000, dateFilter);

      if (res.status !== "success" || !res.data.length) {
        toast.error("No data available to export");
        setLoading(false);
        return;
      }

      // ✅ APPLY SAME SORTING AS TABLE
      const sortedExportData = sortRecords(res.data);

      const exportData = sortedExportData.map((row, index) => ({
        "SR NO": index + 1,
        DISTRICT: row.district_name || "",
        BLOCK: row.block_name || "",
        "GRAM PANCHAYAT": row.panchayat_name || "",
        DATE: row.sabha_date
          ? new Date(row.sabha_date).toISOString().split("T")[0]
          : "",
        TIME: row.sabha_start_time || "",
        "PRESIDING OFFICER NAME": row.presiding_officer_name || "",
        "PRESIDING OFFICER MOBILE": row.presiding_officer_mobile || "",
        "PRESIDING OFFICER DESIGNATION":
          row.presiding_officer_designation || "",
        VENUE: row.venue || "",
        AGENDA: row.agenda ? "Uploaded" : "Not Uploaded",
        "MEETING VIDEO": row.mom_upload ? "Uploaded" : "Not Uploaded",
        "MEETING NOTICE": row.meeting_notice_upload
          ? "Uploaded"
          : "Not Uploaded",
        "PROCEEDING BOOK": row.mom_upload_document
          ? "Uploaded"
          : "Not Uploaded",
        IMAGES: row.image_upload ? "Uploaded" : "Not Uploaded",
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Gram Sabha Meetings");

      XLSX.writeFile(
        workbook,
        `Gram_Sabha_Meetings_${new Date().toISOString().split("T")[0]}.xlsx`
      );

      setLoading(false);
    } catch (error) {
      console.error(error);
      toast.error("Excel export failed");
      setLoading(false);
    }
  };
  return (
    <>
      <style>
        {`
          .MuiTablePagination-actions svg {
            visibility: visible !important;
            fill: #212128;  
          }
          .sticky-top {
            z-index: 1000 !important;
          }
          .date-dropdown-container {
            position: relative;
          }
          .date-dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background: white;
            border: 1px solid #ddd;
            border-radius: 4px;
            max-height: 200px;
            overflow-y: auto;
            z-index: 1000;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }
          .date-option {
            padding: 8px 12px;
            cursor: pointer;
            border-bottom: 1px solid #eee;
          }
          .date-option:hover {
            background-color: #f5f5f5;
          }
          .date-option.selected {
            background-color: #e6f7ff;
            font-weight: bold;
          }
          .date-loading {
            padding: 8px 12px;
            text-align: center;
            color: #666;
            font-style: italic;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <div className="container-fluid">
        <div
          id="loading-coupon"
          style={{
            display: loading ? "flex" : "none",
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.6)",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <img id="loading-image" src={loader} alt="Loading..." />
        </div>

        <div style={{ padding: "16px", marginTop: "-17px" }}>
          <h2
            className="pt-10"
            style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold" }}
          >
            Gram Sabha Meeting Management Portal
          </h2>
        </div>

        {/* Filters - ADD DEBUG INFO */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <div className="sticky-top py-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                    marginBottom: "8px",
                  }}
                >
                  {/* Location filters */}
                  <select
                    className="form-select dropdown-custom"
                    style={{ width: "160px", height: "34px" }}
                    value={selectedDistrictCode}
                    onChange={handleDistrictChange}
                  >
                    <option value="">District</option>
                    {district.map((item) => (
                      <option
                        key={item.district_code}
                        value={item.district_code}
                      >
                        {item.district}
                      </option>
                    ))}
                  </select>

                  <select
                    className="form-select dropdown-custom"
                    style={{ width: "160px", height: "34px" }}
                    value={selectedBlockCode}
                    onChange={handleBlockChange}
                    disabled={!selectedDistrictCode}
                  >
                    <option value="">Block</option>
                    {block.map((item) => (
                      <option key={item.block_code} value={item.block_code}>
                        {item.block}
                      </option>
                    ))}
                  </select>

                  <select
                    className="form-select dropdown-custom"
                    style={{ width: "180px", height: "34px" }}
                    value={selectedVillage}
                    onChange={handleVillageChange}
                    disabled={!selectedBlockCode}
                  >
                    <option value="">Gram Panchayat</option>
                    {village.map((item) => (
                      <option
                        key={item.gram_panchayat_code}
                        value={item.gram_panchayat_code}
                      >
                        {item.gram_panchayat}
                      </option>
                    ))}
                  </select>

                  {/* Date Filter with Debug Info */}
                  <div
                    className="date-dropdown-container"
                    style={{ width: "160px" }}
                  >
                    <div
                      className="form-control"
                      style={{
                        width: "100%",
                        height: "34px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 12px",
                        position: "relative",
                      }}
                      onClick={() => setShowDateDropdown(!showDateDropdown)}
                    >
                      <span
                        style={{ color: selectedDate ? "#000" : "#6c757d" }}
                      >
                        {selectedDate
                          ? selectedDate.format("DD/MM/YYYY")
                          : "Select Date"}
                      </span>
                      <span>▼</span>
                      {datesLoading && (
                        <div
                          style={{
                            position: "absolute",
                            right: "25px",
                            width: "12px",
                            height: "12px",
                            border: "2px solid #f3f3f3",
                            borderTop: "2px solid #3498db",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        ></div>
                      )}
                    </div>

                    {showDateDropdown && (
                      <div className="date-dropdown">
                        {datesLoading ? (
                          <div className="date-loading">Loading dates...</div>
                        ) : availableDates.length > 0 ? (
                          <>
                            <div
                              className="date-option"
                              onClick={() => handleDateChange(null)}
                              style={{
                                color: "#007bff",
                                fontWeight:
                                  selectedDate === null ? "bold" : "normal",
                              }}
                            >
                              All Dates ({availableDates.length} dates)
                            </div>
                            {availableDates.map((dateStr) => {
                              const date = dayjs(dateStr);
                              const isSelected =
                                selectedDate &&
                                selectedDate.format("YYYY-MM-DD") === dateStr;
                              return (
                                <div
                                  key={dateStr}
                                  className={`date-option ${isSelected ? "selected" : ""
                                    }`}
                                  onClick={() => handleDateChange(date)}
                                >
                                  {date.format("DD/MM/YYYY")}
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          <div
                            className="date-option"
                            style={{ color: "#6c757d", textAlign: "center" }}
                          >
                            No meetings found
                          </div>
                        )}
                      </div>
                    )}


                  </div>

                  {/* Debug info - show what's selected */}

                  <Button
                    size="small"
                    variant="outlined"
                    color="secondary"
                    onClick={handleResetFilters}
                    disabled={
                      !selectedDistrictCode &&
                      !selectedBlockCode &&
                      !selectedVillage &&
                      !selectedDate
                    }
                    style={{ height: "34px", minWidth: "70px" }}
                  >
                    Reset
                  </Button>

                  <Button
                    size="small"
                    variant="contained"

                    onClick={handleExportToExcel}
                    style={{ height: "34px", minWidth: "110px" }}
                  >
                    Export Excel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>




        {/* TABLE */}
        <div style={{ overflowX: "auto", marginTop: "20px" }}>
          <Table aria-label="simple table">
            <TableHead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "rgb(232 233 246)",
                whiteSpace: "nowrap",
              }}
            >
              <TableRow>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  SR. NO.
                </TableCell>
                <TableCell align="center" style={{ fontWeight: "bold" }}>
                  <SortableHeader label="DISTRICT" columnKey="district_name" />
                </TableCell>

                <TableCell align="center" style={{ fontWeight: "bold" }}>
                  <SortableHeader label="BLOCK" columnKey="block_name" />
                </TableCell>

                <TableCell align="center" style={{ fontWeight: "bold" }}>
                  <SortableHeader
                    label="GRAM PANCHAYAT"
                    columnKey="panchayat_name"
                  />
                </TableCell>

                <TableCell align="center" style={{ fontWeight: "bold" }}>
                  <SortableHeader label="DATE" columnKey="sabha_date" />
                </TableCell>

                <TableCell align="center" style={{ fontWeight: "bold" }}>
                  <SortableHeader label="TIME" columnKey="sabha_start_time" />
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  PRESIDING OFFICER NAME
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  PRESIDING OFFICER MOBILE
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  PRESIDING OFFICER DESIGNATION
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  VENUE
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  AGENDA
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  MEETING VIDEO
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  MEETING NOTICE
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  PROCEEDING BOOK
                </TableCell>
                <TableCell
                  style={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  align="center"
                >
                  IMAGES
                </TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={16} align="center">
                    No data found
                  </TableCell>
                </TableRow>
              ) : (
                paginatedData.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {index + 1 + page * rowsPerPage}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.district_name}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.block_name}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.panchayat_name}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.sabha_date}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.sabha_start_time}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.presiding_officer_name}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.presiding_officer_mobile}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.presiding_officer_designation}
                    </TableCell>
                    <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                      {row.venue}
                    </TableCell>

                    <TableCell align="center">
                      {row.agenda ? (
                        <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                          <Button
                            onClick={() => handleViewFile(row.agenda)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "60px",
                              padding: "4px 6px",
                            }}
                            title="View Agenda"
                          >
                            <VisibilityIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            View
                          </Button>
                          <Button
                            onClick={() => handleDownloadFile(row.agenda)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "80px",
                              padding: "4px 6px",
                            }}
                            title="Download Agenda"
                          >
                            <DownloadIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            Download
                          </Button>
                        </div>
                      ) : (
                        "-----"
                      )}
                    </TableCell>

                    {/* MOM VIDEO */}
                    <TableCell align="center">
                      {row.mom_upload ? (
                        <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                          <Button
                            onClick={() => handleViewFile(row.mom_upload)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "60px",
                              padding: "4px 6px",
                            }}
                            title="View Video"
                          >
                            <VisibilityIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            View
                          </Button>
                          <Button
                            onClick={() => handleDownloadFile(row.mom_upload)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "80px",
                              padding: "4px 6px",
                            }}
                            title="Download Video"
                          >
                            <DownloadIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            Download
                          </Button>
                        </div>
                      ) : (
                        "-----"
                      )}
                    </TableCell>

                    <TableCell align="center">
                      {row.meeting_notice_upload ? (
                        <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                          <Button
                            onClick={() => handleViewFile(row.meeting_notice_upload)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "60px",
                              padding: "4px 6px",
                            }}
                            title="View Notice"
                          >
                            <VisibilityIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            View
                          </Button>
                          <Button
                            onClick={() => handleDownloadFile(row.meeting_notice_upload)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "80px",
                              padding: "4px 6px",
                            }}
                            title="Download Notice"
                          >
                            <DownloadIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            Download
                          </Button>
                        </div>
                      ) : (
                        "-----"
                      )}
                    </TableCell>

                    {/* MOM DOCUMENT */}
                    <TableCell align="center">
                      {row.mom_upload_document ? (
                        <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                          <Button
                            onClick={() => handleViewFile(row.mom_upload_document)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "60px",
                              padding: "4px 6px",
                            }}
                            title="View Document"
                          >
                            <VisibilityIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            View
                          </Button>
                          <Button
                            onClick={() => handleDownloadFile(row.mom_upload_document)}
                            style={{
                              ...compactBtnStyle,
                              minWidth: "80px",
                              padding: "4px 6px",
                            }}
                            title="Download Document"
                          >
                            <DownloadIcon style={{ fontSize: "14px", marginRight: "2px" }} />
                            Download
                          </Button>
                        </div>
                      ) : (
                        "-----"
                      )}
                    </TableCell>

                    {/* SINGLE IMAGE */}
                    <TableCell align="center">
                      {row.image_upload ? (
                        <Button
                          onClick={() => handleViewImage(row.image_upload)}
                          style={compactBtnStyle}
                          title="View Image"
                        >
                          View
                        </Button>
                      ) : (
                        "-----"
                      )}
                    </TableCell>
                    <TableCell align="center">

                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 20, 50, 100]}
          labelRowsPerPage="Rows per page:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}–${to} of ${count}`
          }
        />

        <ToastContainer />

      </div>
    </>
  );
};

export default ViewMeetingForGramSabhaAdmin;
